import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Mission from "@/components/Mission";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Stories from "@/components/Stories";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import VisionChip from "@/components/VisionChip";
import Admin from "@/pages/Admin";
import Peek from "@/pages/Peek";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-[#F9F8F6] text-[#2A2A2A]">
      <Nav />
      <Hero />
      <About />
      <Mission />
      <Services />
      <Gallery />
      <Stories />
      <Booking />
      <Contact />
      <VisionChip />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/peek" element={<Peek />} />
          <Route path="/peek/:slug" element={<Peek />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
